// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const radiusSix = (props) => `
    ${props.spcBag && props.theme.brand !== 'gym' ? `border-radius: 6px` : ''};
`;

export default css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${(props) => (props.isBagPageSflSection ? 0 : props.theme.spacing.ELEM_SPACING.XXL)};
  .large-size-message {
    text-align: center;
    font-size: ${(props) => props.theme.typography.fontSizes.fs22};
  }
  .small-spacing {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0px;
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
  }
  .element-spacing {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL} 0px;
  }

  .empty-sfl-msg {
    display: block;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    background-color: ${(props) => props.theme.colors.WHITE};
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .large-size-message {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    }
    .small-spacing {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0px;
    }
    .element-spacing {
      margin: ${(props) => props.theme.spacing.ELEM_SPACING.XL} 0px;
    }

    .CTA-button {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 60px;
    }
    .empty-sfl-message {
      max-width: 260px;
    }
  }

  .CTA-button {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1}
      ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
    background-color: ${(props) => props.theme.colors.PRIMARY.DARK};
    ${(props) => radiusSix(props)}
    &:hover {
      background: ${(props) => props.theme.colors.PRIMARY.DARK};
    }
  }
  .guest-sfl-login-section {
    margin: 24px 0px 6px;
  }
`;

export const GuestSFLSection = styled.div`
  text-align: center;
  width: 100%;
`;
